import { createRouter, createWebHistory } from "vue-router";
import { pcRoutes, h5Routes } from "./routes";
import store from "@/store";
import NProgress from "nprogress";
import "nprogress/nprogress.css";
import { setTitle } from "@/utils/help.js";
import { addPageBrowserRecord } from "@/api/platform";

// 基本配置
NProgress.configure({
  easing: "ease", // 动画方式
  speed: 500, // 递增进度条的速度
  showSpinner: false, // 是否显示加载 spinner
  trickleSpeed: 200, // 自动递增间隔
  minimum: 0.3, // 初始化时的最小百分比
});

// 根据屏幕宽度来加载对应的路由
const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes: store.state.app.isMobile ? h5Routes : pcRoutes,
});

const blueThemeRouteNames = ["PublicCourse", "Step1"];

router.beforeEach(async (to, from, next) => {
  // 开始进度条
  NProgress.start();
  // 获取token
  const token = localStorage.getItem("token");
  const getUserInfo = store.getters["user/getUserInfo"];

  if (token) {
    if (!getUserInfo) {
      store.dispatch("user/getUserInfoAction");
    }
  }

  // 获取专科专项
  if (store.getters["course/getZxCourses"].length <= 0) {
    await store.dispatch("course/getZxZk");
  }
  // 获取全部预览课程
  if (store.getters["course/getYhshoueyeCourse"].length <= 0) {
    store.dispatch("course/getShouYeCourses");
  }

  // pc主题设置
  if (!store.getters["app/getIsMobile"]) {
    if (blueThemeRouteNames.includes(to.name)) {
      store.commit("app/setTheme", "theme-blue");
    } else {
      store.commit("app/setTheme", "theme-light");
    }
  }

  next();
});

router.afterEach((to) => {
  // 设置页面title
  if (to.meta?.title) {
    setTitle(to.meta.title);
  }
  if (to.query?._monitor_) {
    let params = {
      linkKey: to.query._monitor_,
      linkUrl: location.href,
    };
    addPageBrowserRecord(params);
  }
  NProgress.done();
});

export default router;
